import React, { useEffect, useState } from 'react';
import { FormComponent, FormComponentProps } from '../index';
import { useWatch } from 'react-hook-form';

export default function Show(
  element: FormComponent | FormComponent[],
  showOn: string | string[],
  callback?: (watchValues: any) => boolean | Promise<boolean>
): FormComponent {
  return ({ ...rest }) => (
    <ShowComponent
      elements={Array.isArray(element) ? element : [element]}
      showOn={showOn}
      callback={callback}
      {...rest}
    />
  );
}

export function ShowComponent({
  elements,
  showOn,
  callback,
  ...rest
}: FormComponentProps & {
  elements: FormComponent[];
  showOn: string | string[];
  callback?: (watchValues: any) => boolean | Promise<boolean>;
}) {
  const watchValues = useWatch({
    name: [showOn].flat().map((name) => {
      // starting slash denotes watch on a root element, otherwise watch a sibling
      if (name.startsWith('/')) {
        return name.substring(1);
      } else if (rest.parentName) {
        return rest.parentName.concat('.', name);
      } else {
        return name;
      }
    }),
  });

  const [showValue, setShowValue] = useState(false);
  useEffect(() => {
    if (callback) {
      const values = typeof showOn === 'string' ? watchValues[0] : watchValues;

      Promise.resolve(callback(values)).then((value) => setShowValue(value));
    } else {
      if (Array.isArray(watchValues)) {
        setShowValue(!watchValues.filter(Boolean));
      } else {
        setShowValue(!watchValues);
      }
    }
  }, [showOn, watchValues, callback]);

  return showValue ? (
    <>
      {elements.filter(Boolean).map((Element, index) => {
        return <Element key={index} {...rest} />;
      })}
    </>
  ) : null;
}
